// extracted by mini-css-extract-plugin
export default {"card":"VZ-z","carouselContainer":"WZ-z","carouselContent":"XZ-z"};